import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import validator from 'validator'
class NewFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
	marketURL:  process.env.REACT_APP_CRYPTO_API_URL,
	cryptoawaj:  process.env.REACT_APP_CRYPTO_URL
    };
  }
   render() {
    const _data = this.state.data;
    console.log("Himani", process.env.REACT_APP_API_URL)
    return (
      <div>
<footer className="footer-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 pull-devices">
                <h4>Products &amp; Services</h4>
                <ul>
                 
                  <li><a href={this.state.marketURL+'wallet'} target="_blank">Wallet</a></li>
                  <li><a href={this.state.marketURL+'crypto-exchanges'}>Exchange</a></li>
                  <li><a href={this.state.cryptoawaj + 'bitcoin-for-business'} target="_blank">Merchant Solutions</a></li>
                </ul>


                
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 pull-devices">
                <h4>Get Crypto</h4>
                <ul>
                  <li><a href="javascript:void(0);">Buy Crypto</a></li>
                  <li><a href="javascript:void(0);">Trade Crypto</a></li>
                  <li><a href={this.state.marketURL+'earn-crypto'} target="_blank">Earn Crypto</a></li>
                </ul>


                
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 pull-devices">
                <h4>Spend Crypto</h4>
                <ul>
                  <li><a href="javascript:void(0);">Sell Crypto</a></li>
                </ul>
               
              </div>
             
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 pull-devices">
                <h4>Crypto Data</h4>
                <ul>
                  <li><a href="https://www.blockchain.com/explorer?utm_campaign=dcomnav_explorer" target="_blank">Block Explorer</a></li>
                  <li><a href="javascript:void(0);">Markets</a></li>
                </ul>
                
              </div>
             
            </div>
          </div>

		<div class="copyright-section">
            <div class="container">
              <div class="copyright-right">
                <a href={`${this.state.cryptoawaj}privacy-policy`} target="_blank">Privacy Policy</a>
                <span>/</span>
                <a href={`${this.state.cryptoawaj}page/terms-&amp;-conditions`} target="_blank">Terms of Use</a>
                <span>/</span>
              
                <a href={`${this.state.cryptoawaj}sitemap`} target="_blank">Sitemap</a>
              </div>
              <p>© 2024-2025 Crypto Awaj All rights reserved</p>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default withTranslation('translations')(NewFooter);